import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Logo from '../../routes/Logo';

export default (props) => {
  let history = useHistory();
  const from = history.location.pathname;
  let [toggled, changeToggled] = useState(false);
  useEffect(() => changeToggled(toggled), [toggled]);
  const toggleMenu = () => changeToggled(!toggled);
  const hideMenu = () => changeToggled(false);

  const getElement = (tab, path) => {
    if (tab.link) {
      return (
        <a target="_blank" href={tab.link} rel="noreferrer">
          <span className="dropdown-option-name">
            <span className="group profile-navigation-icon">
              <i className={'fa fa-' + tab.icon} aria-hidden="true" />
              <span className="menu-tooltip bg-ev-navy-blue group-hover:block">{props.tabs[path].name}</span>
            </span>
            <span className={'profile-navigation-name' + (toggled ? ' toggled' : '')}>{tab.name}</span>
          </span>
        </a>
      );
    } else if (tab.onClick) {
      return (
        <a
          onClick={() => {
            toggleMenu;
            tab.onClick();
          }}
          className={tab.extraClass}
          activeClassName="active"
        >
          <span className="dropdown-option-name">
            <span className="group profile-navigation-icon">
              <i className={'fa fa-' + tab.icon} />
              {!toggled && (
                <span className="menu-tooltip bg-ev-navy-blue group-hover:block">{props.tabs[path].name}</span>
              )}
            </span>
            <span className={'profile-navigation-name' + (toggled ? ' toggled' : '')}>{tab.name}</span>
          </span>
        </a>
      );
    } else {
      return (
        <NavLink onClick={hideMenu} to={{ pathname: path, state: { from } }} activeClassName="active">
          <span className="dropdown-option-name">
            <span className="group profile-navigation-icon">
              <i className={'fa fa-' + tab.icon} />
              {!toggled && (
                <span className="menu-tooltip bg-ev-navy-blue group-hover:block">{props.tabs[path].name}</span>
              )}
            </span>
            <span className={'profile-navigation-name' + (toggled ? ' toggled' : '')}>{tab.name}</span>
          </span>
        </NavLink>
      );
    }
  };

  return (
    <div className="profile-nav">
      <div className={'navtoggle' + (toggled ? ' toggled' : '')}>
        <div>
          <Logo />
          <span onClick={hideMenu} className="close-menu">
            <i className="fa fa-times" aria-hidden="true"></i>
          </span>
        </div>
        <ul className={'nav nav-tabs level-' + props.level}>
          {props.tabs &&
            Object.keys(props.tabs).map((path, index) => {
              return <li key={index}>{getElement(props.tabs[path], path)}</li>;
            })}

          <li>
            <NavLink onClick={hideMenu} to={props.paths.vizPicker} activeClassName="active">
              <span className="dropdown-option-name">
                <span className="profile-navigation-icon">
                  <i className="fa fa-plus" aria-hidden="true" />
                </span>
                <span className={'profile-navigation-name' + (toggled ? ' toggled' : '')}>New project</span>
              </span>
            </NavLink>
          </li>
        </ul>
      </div>
      <div className={`navigation-container-vertical ${toggled ? ' toggled' : ''}`}>
        <Logo />
        <span className="menu" onClick={toggleMenu}>
          <i className="fa fa-bars" aria-hidden="true"></i>
        </span>

        <nav className="nav-tab overflow-hidden whitespace-nowrap">
          <ul className={'nav nav-tabs level-' + props.level}>
            {props.tabs &&
              Object.keys(props.tabs).map((path, index) => {
                return (
                  <li key={index} className={'profile-nav-' + props.tabs[path].icon}>
                    {getElement(props.tabs[path], path)}
                  </li>
                );
              })}
          </ul>
        </nav>
      </div>
    </div>
  );
};
